import {
  addDoc,
  collection,
  doc,
  getDocs,
  getFirestore,
  getDoc,
  query,
  updateDoc,
  where,
  serverTimestamp,
  deleteDoc,
} from "firebase/firestore";
import firebaseApp from "../../firebase/credenciales";
import { CONT_COLLECTIONS } from "./collections";
import { registrarDocumentoComercial } from "./documentosComercialesService";
import { obtenerSiguienteCorrelativo } from "./correlativosService";

const db = getFirestore(firebaseApp);

// --- Maestros: Proveedores ---
export const obtenerProveedores = async (rucEmpresa) => {
  const q = query(collection(db, CONT_COLLECTIONS.PROVEEDORES), where("ruc_empresa", "==", rucEmpresa));
  const snap = await getDocs(q);
  return snap.docs.map(d => ({ id: d.id, ...d.data() }));
};

export const guardarProveedor = async (rucEmpresa, proveedor) => {
  const id = `${rucEmpresa}_${proveedor.ruc}`.replace(/[^\w-]/g, "_");
  const ref = doc(db, CONT_COLLECTIONS.PROVEEDORES, id);
  await updateDoc(ref, {
    ...proveedor,
    ruc_empresa: rucEmpresa,
    updated_at: serverTimestamp()
  }, { merge: true });
  return id;
};

// --- Maestros: Catálogo de Ítems ---
export const obtenerItemsCatalogo = async (rucEmpresa) => {
  const q = query(collection(db, CONT_COLLECTIONS.ITEMS_CATALOGO), where("ruc_empresa", "==", rucEmpresa));
  const snap = await getDocs(q);
  return snap.docs.map(d => ({ id: d.id, ...d.data() }));
};

export const guardarItem = async (rucEmpresa, item) => {
  const payload = {
    ...item,
    ruc_empresa: rucEmpresa,
    updated_at: serverTimestamp()
  };
  if (item.id) {
    const ref = doc(db, CONT_COLLECTIONS.ITEMS_CATALOGO, item.id);
    await updateDoc(ref, payload);
    return item.id;
  } else {
    payload.created_at = serverTimestamp();
    const ref = await addDoc(collection(db, CONT_COLLECTIONS.ITEMS_CATALOGO), payload);
    return ref.id;
  }
};

// --- Órdenes de Compra (OC) ---
export const obtenerOrdenesCompra = async (rucEmpresa) => {
  const q = query(collection(db, CONT_COLLECTIONS.ORDENES_COMPRA), where("ruc_empresa", "==", rucEmpresa));
  const snap = await getDocs(q);
  return snap.docs.map(d => ({ id: d.id, ...d.data() }));
};

export const crearOrdenCompra = async (rucEmpresa, oc) => {
  const { correlativo, secuencia } = await obtenerSiguienteCorrelativo({
    rucEmpresa,
    prefijo: "OC",
  });

  const payload = {
    ...oc,
    ruc_empresa: rucEmpresa,
    correlativo,
    secuencia,
    estado: "BORRADOR",
    visto_bueno: false,
    documentos_relacionados: [],
    created_at: serverTimestamp(),
    updated_at: serverTimestamp()
  };
  const ref = await addDoc(collection(db, CONT_COLLECTIONS.ORDENES_COMPRA), payload);

  const docId = await registrarDocumentoComercial({
    rucEmpresa,
    tipoDocumento: "ORDEN_COMPRA",
    serie: "OC",
    numero: correlativo,
    fecha: new Date().toISOString().slice(0, 10),
    monto: payload.total,
    moneda: payload.moneda || "PEN",
    moduloOrigen: "GESTION_COMPRAS",
    entidadId: ref.id,
    entidadTipo: "ORDEN_COMPRA",
    relacionadoCon: [],
    metadata: {
      proveedor_ruc: payload.proveedor_ruc,
      proveedor_razon_social: payload.proveedor_razon_social,
    },
  });

  await updateDoc(doc(db, CONT_COLLECTIONS.ORDENES_COMPRA, ref.id), {
    documentos_relacionados: [{ id: docId, tipo: "ORDEN_COMPRA" }],
    updated_at: serverTimestamp(),
  });

  return ref.id;
};

export const certificarOC = async (ocId, usuario) => {
  const ref = doc(db, CONT_COLLECTIONS.ORDENES_COMPRA, ocId);
  await updateDoc(ref, {
    estado: "APROBADO",
    visto_bueno: true,
    aprobado_por: usuario,
    aprobado_en: new Date().toISOString(),
    updated_at: serverTimestamp()
  });
};

export const cerrarOC = async (ocId) => {
  const ref = doc(db, CONT_COLLECTIONS.ORDENES_COMPRA, ocId);
  await updateDoc(ref, {
    estado: "CERRADO",
    updated_at: serverTimestamp()
  });
};
